<div class="h-full flex flex-col min-h-0">
  <!-- HEADER (cards + buscador) -->
  <div class="shrink-0">
    <!-- cards -->
    <div class="flex gap-4 mb-6">
      <div class="bg-white rounded-lg shadow p-4 flex-1">
        <div class="flex gap-4 items-center">
          <div class="bg-blue-100 text-blue-600 px-3 py-2 rounded-md text-2xl">
            <i class="bi bi-currency-dollar"></i>
          </div>
          <div>
            <p class="text-gray-500">Total Créditos Activos</p>
            <h2 class="text-2xl">
              {{ $safeNavigationMigration(resumenGeneral()?.totalCreditoOtorgado) | currency: 'PEN' : 'S/. ' }}
            </h2>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow p-4 flex-1">
        <div class="flex gap-4 items-center">
          <div class="bg-green-100 text-green-600 px-3 py-2 rounded-md text-2xl">
            <i class="bi bi-people-fill"></i>
          </div>
          <div>
            <p class="text-gray-500">Clientes con Créditos</p>
            <h2 class="text-2xl">{{ resumenGeneral()?.totalClientesConCredito }}</h2>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow p-4 flex-1">
        <div class="flex gap-4 items-center">
          <div class="bg-yellow-100 text-yellow-600 px-3 py-2 rounded-md text-2xl">
            <i class="bi bi-clock-history"></i>
          </div>
          <div>
            <p class="text-gray-500">Ventas pendientes</p>
            <h2 class="text-2xl">{{ resumenGeneral()?.ventasPendientes }}</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- buscador -->
    <div class="flex gap-2 items-center mb-4">
      <app-input-buscador
        placeholder="Buscar cliente por nombre o teléfono"
        [(valor)]="busqueda"
        class="flex-1"
        (presionaEnter)="onBuscar()"
      />
    </div>
  </div>

  <!-- BODY (TABLA CON SCROLL) -->
  <div class="flex-1 min-h-0 overflow-y-auto">
    <app-tabla
      [columnas]="columnasTabla"
      [datos]="paginacion()?.data || []"
      [accionesTemplate]="accionesTemplate"
    />
  </div>

  <!-- FOOTER (PAGINACIÓN FIJA) -->
  @if (paginacion() != null) {
    <div class="shrink-0">
      <app-paginacion
        [items]="paginacion()!.data"
        [itemsPorPagina]="paginacion()!.size"
        [totalItems]="paginacion()!.total"
        (paginaCambiada)="cambiarPagina($event)"
      />
    </div>
  }
</div>
<!-- template columnas -->
<ng-template #telefonoTemplate let-row> {{ row.numero_celular | telefono }} </ng-template>
<ng-template #deudaTemplate let-row>
  {{ row.totalCredito | currency: 'PEN' : 'S/. ' }}
</ng-template>
<ng-template #accionesTemplate let-row>
  <app-button
    icon="bi bi-eye"
    class="mr-2"
    variant="info"
    appTooltip="Ver Créditos"
    tooltipPosition="top"
    (onClick)="verCreditos(row)"
  />
</ng-template>
